import React from 'react';
import {
  Box,
  HeadingText,
  StackItem,
  StackLayout,
  UtilityText,
} from '@leagueplatform/genesis-core';
import {
  ShapeIcon,
  shapes,
} from '#components/charts/core/xychart/primitives/Shape.tsx';

export type OverviewPanelProps = {
  items: {
    titleText: string;
    textBlocks: {
      heroText: string;
      subText?: string;
    }[];
    order?: number;
  }[];
};

export function OverviewPanel({ items }: OverviewPanelProps) {
  return (
    <StackLayout
      orientation="horizontal"
      horizontalAlignment="center"
      spacing="$three"
    >
      {items.map(({ titleText, textBlocks, order }) => {
        const shape = order != null ? shapes[order] : null;

        return (
          <StackItem horizontalAlignment="center" key={titleText}>
            <StackLayout
              orientation="horizontal"
              verticalAlignment="center"
              spacing="$quarter"
            >
              {shape && <ShapeIcon shape={shape} />}
              <HeadingText level="4" size="md" emphasis="subtle">
                {titleText.toLocaleUpperCase()}
              </HeadingText>
            </StackLayout>
            <StackLayout orientation="horizontal" spacing="$half">
              {textBlocks.map(({ heroText, subText }) => (
                <Box css={{ whiteSpace: 'nowrap' }}>
                  <UtilityText
                    css={{
                      typography: '$headingOne',
                      marginInlineEnd: '$quarter',
                    }}
                  >
                    {heroText}
                  </UtilityText>
                  {subText ? (
                    <UtilityText
                      emphasis="subtle"
                      css={{
                        typography: '$bodyOne',
                      }}
                    >
                      {subText}
                    </UtilityText>
                  ) : null}
                </Box>
              ))}
            </StackLayout>
          </StackItem>
        );
      })}
    </StackLayout>
  );
}
